/**
 * Created by Sam on 2019/3/21.
 */
// import * as iakit from 'iakit'

// import 'iakit/dist/style.css'

import { isAndroid, isIOS } from '@/utils/platform'

class MicoJSBridge {
  static androidObjName = 'Android'
  static iOSObjName = 'iOS'

  static promiseHandler(method, resolve, reject) {
    MicoJSBridge[method] = json => {
      try {
        const { success = false, ...result } = typeof json === 'string' ? JSON.parse(
          json.replace(/[\u{0000}-\u{001F}]/gu, '').replace(/"nickName":"(.*?)",/gu, '').replace(/"nickName":"(.*?)",("\w+?":)/g, '$2')
        ) : typeof json === 'object' ? json : { success: true }
        return success ? resolve(result) : reject(result)
      } catch (error) {
        console.error(`title=${method}&json=${json}`)
        location.href = `https://www.xparty.me/Recharge_Reward/test.html?title=${method}&json=${json}`
        console.log(error)
        return reject(error)
      }
    }
  }

  static injectObj(args) {
    if (args.length) {
      return MicoJSBridge.addMethods(args)
    }

    return MicoJSBridge.log('parameters error!')
  }

  static callBack(method) {
    return (...argumentList) => {
      const args = argumentList.map(arg => JSON.stringify(arg))

      if (isAndroid) {
        if (typeof window[MicoJSBridge.androidObjName] !== 'undefined') {
          if (typeof window[MicoJSBridge.androidObjName][method] !== 'undefined') {
            return new Promise((resolve, reject) => {
              MicoJSBridge.promiseHandler(method, resolve, reject)
              window[MicoJSBridge.androidObjName][method](...args)
            })
          } else {
            return MicoJSBridge.log('android webview do not define method ' + method)
          }
        } else {
          return MicoJSBridge.log('android webview do not define obj ' + MicoJSBridge.androidObjName)
        }
      }

      if (isIOS) {
        if (MicoJSBridge.iOSObjName !== '') {
          if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers[MicoJSBridge.iOSObjName] !== 'undefined') {
            const o1 = window.webkit.messageHandlers[MicoJSBridge.iOSObjName]
            return new Promise((resolve, reject) => {
              MicoJSBridge.promiseHandler(method, resolve, reject)
              o1.postMessage({ method, parameter: args })
            })
          } else {
            return MicoJSBridge.log('ios webview do not define object ' + MicoJSBridge.iOSObjName)
          }
        } else {
          if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers[method] !== 'undefined') {
            const o2 = window.webkit.messageHandlers[method]
            return new Promise((resolve, reject) => {
              MicoJSBridge.promiseHandler(method, resolve, reject)
              o2.postMessage.apply(o2, args)
            })
          } else {
            return MicoJSBridge.log('ios webview do not define object ' + method)
          }
        }
      }

      return MicoJSBridge.log('call in moblie webview')
    }
  }

  static addMethods(methods) {
    for (const method of methods) {
      MicoJSBridge[method] = MicoJSBridge.callBack(method)
    }

    if (isAndroid && typeof window[MicoJSBridge.androidObjName] !== 'undefined') {
      for (const method in window[MicoJSBridge.androidObjName]) {
        if (!methods.includes(method)) {
          MicoJSBridge[method] = MicoJSBridge.callBack(method)
        }
      }
    }
  }

  static create(...args) {
    MicoJSBridge.injectObj(args)
    return (window.MicoJSBridge = MicoJSBridge)
  }

  static log(text) {
    return Promise.reject(new Error('MicoJSBridge: ' + text))
  }
}

export const {
  h5_obtainSupportedMethods: h5ObtainSupportedMethods,
  h5_obtainAccessToken: h5ObtainAccessToken,
  h5_obtainDeviceInfo: h5ObtainDeviceInfo,
  h5_obtainProfile: h5ObtainProfile,
  h5_exit: h5Exit,
  h5_mail: h5Mail,
  h5_openBrowser: h5OpenBrowser,
  h5_share: h5Share,
  h5_obtainStreamerUid: h5ObtainStreamerUid,
  h5_obtainFeedbackInfo: h5ObtainFeedbackInfo,
  h5_uploadLog: h5UploadLog,
  h5_trackFireBaseEvent: h5TrackFireBaseEvent,
  h5_requestCP: h5RequestCP,
  h5_goAudioRoom: h5GoAudioRoom,
  h5_obtainCompetitors: h5ObtainCompetitors,
  h5_obtainRoomSession: h5ObtainRoomSession,
  h5_logout: h5Logout,
  h5_login: h5Login,
  h5_chatMessage: h5ChatMessage,
  h5_saveImage: h5SaveImage
} = MicoJSBridge.create(
  'h5_obtainSupportedMethods',
  'h5_obtainProfile',
  'h5_obtainDeviceInfo',
  'h5_obtainAccessToken',
  'h5_exit',
  'h5_mail',
  'h5_openBrowser',
  'h5_share',
  'h5_obtainStreamerUid',
  'h5_obtainFeedbackInfo',
  'h5_uploadLog',
  'h5_trackFireBaseEvent',
  'h5_requestCP',
  'h5_goAudioRoom',
  'h5_obtainCompetitors',
  'h5_obtainRoomSession',
  'h5_logout',
  'h5_login',
  'h5_chatMessage',
  'h5_saveImage'
)

export default MicoJSBridge
